import React from 'react';
import StandardModal, { ModalBody } from "./Fundamentals/Modal/StandardModal";
import { useTranslation } from "react-i18next";
import helpers from "../Utils/helpers";

function ProductInformationModal({ productInfo}) {
    const {t} = useTranslation();

    return (
        <StandardModal title={productInfo?.productName}>
            <ModalBody>
                <div>
                    <p><strong>{t("productOverview.productOwnerName")}:</strong> {productInfo?.productOwner}</p>
                    <p><strong>{t("productOverview.productOwnerEmail")}:</strong> {productInfo?.productOwnerEmail}</p>
                </div>
                <div>{helpers.parseText(productInfo?.notes)}</div>
            </ModalBody>
        </StandardModal>
    )
}
export default ProductInformationModal;